import type { Role } from '@/stores/session';

export type TaskStatus = 'todo' | 'in_progress' | 'done' | 'cancelled';
export type TaskPriority = 'low' | 'medium' | 'high';

/** Only managers create/edit/delete tasks (backend TASK_MANAGE_ROLES). Everyone
 *  else gets read-only. */
const TASK_MANAGE_ROLES: ReadonlySet<Role> = new Set(['super_admin', 'founder', 'hr']);

export const canManageTasks = (role: Role | null): boolean =>
  role != null && TASK_MANAGE_ROLES.has(role);

export const TASK_STATUSES: { value: TaskStatus; label: string }[] = [
  { value: 'todo', label: 'To do' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'done', label: 'Done' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const TASK_PRIORITIES: { value: TaskPriority; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const STATUS_LABEL: Record<TaskStatus, string> = Object.fromEntries(
  TASK_STATUSES.map((s) => [s.value, s.label]),
) as Record<TaskStatus, string>;

export const PRIORITY_LABEL: Record<TaskPriority, string> = Object.fromEntries(
  TASK_PRIORITIES.map((p) => [p.value, p.label]),
) as Record<TaskPriority, string>;
